module.exports = __webpack_public_path__ + "static/media/mobile_dicero_page_area01_img_en.2537c8a9.png";